var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { environment } from '../../constants';
var getUtpConfiguration = function (env) { return ({
    UTPConfig: {
        ComponentId: 'ToBeUpdated',
        ComponentName: 'SmartParkingUI',
        EnvironmentName: env,
        Service: 'Parking',
        ServiceLine: 'Digital Workplace',
        ServiceOffering: 'End User Services Engineering',
    },
}); };
var getCommonTelemetryConfig = function (env) { return (__assign({ disableCorrelationHeaders: false, disableAjaxTracking: false, disableFetchTracking: false, enableAjaxErrorStatusText: true, enableCorsCorrelation: true }, getUtpConfiguration(env))); };
export var getTelemetryConfig = function (env, clientId) {
    return env === 'prod'
        ? __assign(__assign({ instrumentationKey: '83cdfb65-e3c2-46c5-818f-ec82d96fb3d3' }, getCommonTelemetryConfig(environment.PROD)), { usageTelemetryConfig: {
                usageApi: {
                    headers: {
                        'SmartParking-Apim-Subscription-Key': '347ff7db663c4de5bd134bb994f19b38',
                    },
                    method: 'GET',
                    resourceId: clientId,
                    url: 'https://dwp.azure-api.net/partners/usageuserid/',
                    cache: 'localStorage',
                },
                enableUpnLogging: false,
                sessionDurationMinutes: 15,
            } }) : __assign(__assign({ instrumentationKey: 'fea8c4cc-a124-42db-b037-a6f34692ca74' }, getCommonTelemetryConfig(environment.PPE)), { usageTelemetryConfig: {
            usageApi: {
                headers: {
                    'SmartParking-Apim-Subscription-Key': 'da948780866146898ca45ada089abaa0',
                },
                method: 'GET',
                resourceId: clientId,
                url: 'https://dwp-nonprod.azure-api.net/partners/usageuserid/',
                cache: 'localStorage',
            },
            enableUpnLogging: false,
            sessionDurationMinutes: 15,
        } });
};
